const ComposeLink = (product) => {
    const { item_code, brand_name_new, brand, segment_range_new, recipe } = product
    const brandProcessed = formatString(brand_name_new || brand)
    const segmentProcessed = formatString(segment_range_new)
    const recipeProcessed = formatString(recipe)

    return concatStrings(item_code, brandProcessed, segmentProcessed, recipeProcessed)
}

const concatStrings = (...strings) => {
    return strings.reduce((total, current) => {
        if (current) {
            return total.concat(current)
        }
        return total
    }, '')
}

const formatString = str => {
    if (!str) {
        return ''
    }
    const trimmed = str.trim()
    if (!trimmed) {
        return ''
    }

    const formatted = `-${trimmed.replace(/\s+/g, '-')}`
    return formatted.replace(/[-]{2,}/gi, '-')
}

module.exports = ComposeLink; 